export const DEFAULT_AI_TOOLKIT_SEARCH_LIMIT = 10;

export const normalizeAiToolkitSearchQuery = (query: string | undefined): string | undefined => {
  const normalizedQuery = query?.trim().toLocaleLowerCase();

  return normalizedQuery || undefined;
};

export const normalizeAiToolkitFilterValue = (value: string | undefined): string | undefined => {
  const normalizedValue = value?.trim();

  return normalizedValue || undefined;
};

export const matchesAiToolkitSearchQuery = ({
  query,
  values,
}: {
  query: string | undefined;
  values: Array<string | null | undefined>;
}): boolean => {
  if (!query) return true;

  return values.some(value => value?.toLocaleLowerCase().includes(query));
};

export const compareIsoStringsAscending = ({
  left,
  right,
}: {
  left: string | null | undefined;
  right: string | null | undefined;
}): number => {
  if (!left && !right) return 0;
  if (!left) return 1;
  if (!right) return -1;

  return left.localeCompare(right);
};

export const compareIsoStringsDescending = ({
  left,
  right,
}: {
  left: string | null | undefined;
  right: string | null | undefined;
}): number => {
  return compareIsoStringsAscending({ left: right, right: left });
};
